Object.defineProperty(exports, "__esModule", { value: true });
var Sequence_1 = require("./Sequence");
var DistinctByIterator = /** @class */ (function () {
    function DistinctByIterator(iterator, selector) {
        this.iterator = iterator;
        this.selector = selector;
        this.keys = [];
    }
    DistinctByIterator.prototype.next = function (value) {
        for (var item = this.iterator.next(); !item.done; item = this.iterator.next()) {
            var key = this.selector(item.value);
            if (this.keys.indexOf(key) < 0) {
                this.keys.push(key);
                return { done: false, value: item.value };
            }
        }
        return { done: true, value: undefined };
    };
    return DistinctByIterator;
}());
var DistinctBy = /** @class */ (function () {
    function DistinctBy() {
    }
    /**
     * Returns a new sequence which discards all elements with duplicate items determined
     * by the given `selector`.
     *
     * @param {(item: T) => K} selector
     * @returns {Sequence<T>}
     */
    DistinctBy.prototype.distinctBy = function (selector) {
        return Sequence_1.createSequence(new DistinctByIterator(this.iterator, selector));
    };
    return DistinctBy;
}());
exports.DistinctBy = DistinctBy;
//# sourceMappingURL=distinctBy.js.map